<div class="feeder-card" [class.is-collapsed]="!expanded">
  <!-- En compacto la cabecera expande/colapsa la tarjeta -->
  <div class="feeder-card__head" (click)="toggleExpanded()">
    <div class="feeder-card__name">
      <em
        id="check-feeder"
        class="far c-pointer feeder-card__check"
        [class]="feeder.checked ? 'fa-check-circle' : 'fa-circle'"
        (click)="onToggle($event)"
      ></em>
      <span>{{ feeder.name }}</span>
    </div>
    <div class="feeder-card__summary">
      <!-- Estado del frame en la cola del backend mientras espera respuesta -->
      <span
        class="feeder-card__queue is-waiting"
        *ngIf="feeder.queue_status === 'waiting'"
        placement="top"
        container="body"
        [ngbTooltip]="'panel-alerts.queue-waiting-tooltip' | translate"
      >
        <em class="fa fa-hourglass-half" aria-hidden="true"></em>
        <span class="feeder-card__queue-label">{{ "panel-alerts.queue-waiting" | translate }}</span>
      </span>
      <span
        class="feeder-card__queue is-sent"
        *ngIf="feeder.queue_status === 'sent'"
        placement="top"
        container="body"
        [ngbTooltip]="'panel-alerts.queue-sent-tooltip' | translate"
      >
        <em class="fa fa-paper-plane" aria-hidden="true"></em>
        <span class="feeder-card__queue-label">{{ "panel-alerts.queue-sent" | translate }}</span>
      </span>
      <span class="feeder-card__badge" *ngIf="statusIcon" [ngClass]="'is-' + status">
        <em class="fa" [ngClass]="statusIcon" aria-hidden="true"></em>
      </span>
      <span class="feeder-card__progress" *ngIf="total > 0">{{ done }}/{{ total }}</span>
      <em class="fa fa-chevron-down feeder-card__chevron" aria-hidden="true"></em>
    </div>
  </div>

  <p class="feeder-card__condition" *ngIf="feeder.text_condition">{{ feeder.text_condition }}</p>

  <div class="feeder-card__rows">
    <ng-container *ngFor="let alert of feeder.alerts; trackBy: trackByAlert">
      <!-- Los comandos de potencia se agrupan en una sola fila fuera del loop -->
      <app-panel-command-row
        *ngIf="alert.alert !== 'turn_on' && alert.alert !== 'turn_off'"
        [feeder]="feeder"
        [alert]="alert"
        [timezone]="timezone"
        (retry)="onRetry($event)"
      ></app-panel-command-row>
    </ng-container>

    <!-- Fila unica de potencia: muestra siempre el ultimo estado (encendido o apagado) -->
    <app-panel-command-row
      *ngIf="powerAlert"
      [feeder]="feeder"
      [alert]="powerAlert"
      [timezone]="timezone"
      (retry)="onRetry($event)"
    ></app-panel-command-row>

    <p class="feeder-card__idle" *ngIf="feeder.alerts.length === 0">
      {{ "panel-alerts.no-commands-sent" | translate }}
    </p>
  </div>
</div>
